import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './Intro.scss'

const Intro = ({ header, body, center, fontColor }) => (
	<div styleName={center ? 'container-center' : 'container'}>
		<h2 styleName="header" style={{ color: fontColor }}>
			{header}
		</h2>
		{body ? (
			<div styleName="body" style={{ color: fontColor }}>
				{body}
			</div>
		) : (
			''
		)}
	</div>
)

Intro.propTypes = {
	header: React.PropTypes.string,
	body: React.PropTypes.any
}

export default CSSModules(Intro, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Layout/Intro.js